<!-- !! Attention: Student account會共用呢個page，留意返啲permission !! -->
<!-- Remarks:
  - 修改
    -> 待付款 (status = 'pending') -> pay tuition page
    -> 待審核 (status = 'processing') / 已付款 (status = 'paid') -> open pop up
  
  - 下載收據
    -> Conditions:
      * 訂單為已付款/已退款
      
  - 退款
    -> Conditions:
      * 如訂單為已退款 (status = 'debit') / 已作廢發票 (status = 'void')，不可退款
      * 如訂單為線上課程，不可退款
    -> Result:
      * 可以揀要退邊啲堂，會remove咗lesson "paid" list入面嘅學生。唔會影響attendance
      * 可以揀要退邊啲product，會影響inventory
      * 訂單改為已退款

  - 審核付款
    -> Conditions:
      * 訂單為待審核/待付款
    -> Result:
      * 訂單改為已付款

  - 作廢發票
    -> Conditions:
      * 訂單為未付款/待審核/已付款
    -> Result:
      * lesson: remove `students`,`attendance`,`paid`,`exit`,`package_quote` [TODO (BUG): `monthly_used` ??]
      * product: 會影響inventory
      * 訂單改為已作廢發票
-->
<template>
  <v-container fluid>
    <PageHeaderSlot :showBackButton="sid !== null || onlineCourseId !== null" />

    <Datatable
      :isLoading="tableLoading"
      :tableHeaders="tableHeaders"
      :tableData="tableData"
      :page.sync="filter.page"
      :pageLimit.sync="filter.limit"
      :itemTotal="tableItemTotal"
      enableSearch
      @search-clicked="searchKeyword($event)"
      @search-input="filter.keyword = $event"
      enableClearAll
      @all-search-cleared="clearSearch()"
      @refresh-clicked="refreshData()"
      enableRefresh
      @options-update="getOrderData()"
      :enableSearchDate="isAppMode(['T01'])"
      datePlaceholder="searchOrderDate"
      @date-selected="searchOrderDate($event)"
      :enableDateRange="!isAppMode(['T01'])"
      dateRangePlaceholder="searchOrderDate"
      @daterange-selected="searchOrderDateRange($event)"
      :enableExport="!isStudent && !isAppMode(['T03'])"
      @export-clicked="exportData()"
      :exporting="exportLoading"
      :initSearchKeyword="$route.query.search"
      :enableMultiTypeSearch="!disabledMultiTypeSearch"
      :searchTypeOptions="searchTypeOptions"
      :searchType.sync="filter.searchType"
      :enableSelectToggle="enableSelect"
      :selectedTableRow.sync="selectedTableRow"
      @selected-row-changed="onBulkDownloadRowChanged()"
      :tempDisableSelect="bulkDownloading"
      :initSearchDate="filter.date"
    >
      <template v-slot:[`item.status`]="{ item }">
        <TableDropdown
          :show="!!(item.status !== 'void' || item.payment_image_list.length || canViewLog)"
          :display="!downloadLoading"
        >
          <template slot="prepend">
            <v-chip
              :class="{
                'chip-success': item.status === 'paid',
                'chip-active': item.status === 'processing',
                'chip-inactive': item.status !== 'paid' && item.status !== 'processing',
              }"
            >
              {{ item.status | formatOrderStatus }}
            </v-chip>
            <template v-if="item.status !== 'void' && !isStudent">
              <template
                v-if="
                  !isAppMode(['T45']) &&
                    canAdvancedEditOrder &&
                    (item.status === 'pending' || item.status === 'processing')
                "
              >
                <!-- 複製付款連結：如訂單為未付款/待審核 -->
                <v-btn
                  depressed
                  text
                  color="colorBlack"
                  :ripple="false"
                  small
                  @click.prevent="copyPaymentLink(item.id)"
                  class="pa-1 mx-1"
                >
                  <v-icon size="12">{{ icon.mdiContentCopy }}</v-icon>
                  {{ $t('paymentLinkName') }}
                </v-btn>
                <!-- WhatsApp傳送連結：如訂單為未付款/待審核，傳送繳款通知 -->
                <v-btn
                  depressed
                  text
                  color="colorBlack"
                  :ripple="false"
                  small
                  @click.prevent="handleSendWts(item.id, 'unpaid')"
                  class="pa-1 mx-1"
                >
                  <v-icon size="15" color="whatsapp">{{ icon.mdiWhatsapp }}</v-icon>
                  {{ $t('paymentLinkName') }}
                </v-btn>
              </template>
              <template v-else-if="item.status === 'paid'">
                <!-- 複製收據連結：如訂單為已付款 -->
                <v-btn
                  depressed
                  text
                  color="colorBlack"
                  :ripple="false"
                  small
                  @click.prevent="copyReceiptLink(item.id)"
                  class="pa-1 mx-1"
                  :disabled="downloadLoading"
                >
                  <v-icon size="12">{{ icon.mdiContentCopy }}</v-icon>
                  {{ $t('receiptLink') }}
                </v-btn>
                <!-- WhatsApp傳送連結：如訂單為已付款，傳送通知 -->
                <v-btn
                  v-if="!isAppMode(['T45'])"
                  depressed
                  text
                  color="colorBlack"
                  :ripple="false"
                  small
                  @click.prevent="handleSendWts(item.id, 'paid')"
                  class="pa-1 mx-1"
                  :disabled="downloadLoading"
                >
                  <v-icon size="15" color="whatsapp">{{ icon.mdiWhatsapp }}</v-icon>
                  {{ $t('receiptLink') }}
                </v-btn>
              </template>
            </template>
            <v-progress-circular indeterminate color="colorGrey" :size="15" width="3" v-if="downloadLoading" />
          </template>
          <template slot="list">
            <!-- 檢視付款記錄 -->
            <v-list-item
              v-if="item.payment_image_list.length"
              @click.prevent="viewPaymentRecordImg(item.payment_image_list)"
            >
              <v-list-item-title>{{ $t('viewPaymentRecord') }}</v-list-item-title>
            </v-list-item>
            <template v-if="item.status !== 'void'">
              <!-- 修改 -->
              <v-list-item
                v-if="canEditOrder"
                @click.prevent="handleEditOrder(item)"
                :disabled="$store.getters.isLoading"
              >
                <v-list-item-title>{{ $t('edit') }}</v-list-item-title>
              </v-list-item>
              <!-- 下載發票 -->
              <v-list-item v-if="!isAppMode(['T01'])" :disabled="downloadLoading" @click="exportInvoice(item.id)">
                <v-list-item-title>{{ $t('downloadPreInvoice') }}</v-list-item-title>
              </v-list-item>
              <!-- 下載收據：如訂單為已付款/已退款 -->
              <v-list-item
                v-if="item.status === 'paid' || item.status === 'debit'"
                :disabled="downloadLoading"
                @click="exportReceipt(item.id)"
              >
                <v-list-item-title>{{ $t('downloadInvoice') }}</v-list-item-title>
              </v-list-item>
              <!-- 退款詳情：如訂單為已退款 -->
              <v-list-item v-if="item.refund && !item.is_redeem" @click.prevent="openRefundDetails(item.id)">
                <v-list-item-title>{{ $t('refundDetails') }}</v-list-item-title>
              </v-list-item>
              <!-- 退款：如訂單未退過款 & 不是已作廢發票 & 不是online course order -->
              <v-list-item
                v-if="
                  canAdvancedEditOrder && !item.refund && !item.is_redeem && !item.order_type.includes('online_course')
                "
                @click.prevent="handleRefund(item.id)"
                :disabled="$store.getters.isLoading"
              >
                <v-list-item-title>{{ $t('refund') }}</v-list-item-title>
              </v-list-item>
              <!-- 審核付款：如訂單為未付款/待審核，會將該訂單狀態變為"已付款" -->
              <v-list-item
                v-if="canAdvancedEditOrder && (item.status === 'pending' || item.status === 'processing')"
                :disabled="$store.getters.isLoading"
                @click.prevent="handleApproveOrder(item.id)"
              >
                <v-list-item-title>{{ $t('approveOrder') }}</v-list-item-title>
              </v-list-item>
              <!-- 作廢發票：如訂單為未付款/待審核/已付款 -->
              <v-list-item
                v-if="
                  canAdvancedEditOrder &&
                    !item.is_redeem &&
                    (item.status === 'pending' || item.status === 'processing' || item.status === 'paid')
                "
                @click.prevent="handleVoidOrder(item.id)"
                :disabled="$store.getters.isLoading"
              >
                <v-list-item-title>{{ $t('voidOrder') }}</v-list-item-title>
              </v-list-item>

              <!-- 檢視簽名 -->
              <v-list-item
                v-if="isAppMode(['T21']) && item.payment_method === 'cash' && item.sign"
                @click.prevent="viewImg(item.sign)"
              >
                <v-list-item-title>{{ $t('viewSign') }}</v-list-item-title>
              </v-list-item>
              <!-- 付款（for 學生 user） -->
              <v-list-item
                v-if="isStudent && (item.status === 'pending' || item.status === 'processing')"
                @click.prevent="openPaymentLink(item.id)"
              >
                <v-list-item-title>{{ $t('pay') }}</v-list-item-title>
              </v-list-item>
            </template>
            <!-- Log紀錄 -->
            <v-list-item v-if="canViewLog" @click.prevent="openLogRecord(item.id)">
              <v-list-item-title>{{ $t('logRecord') }}</v-list-item-title>
            </v-list-item>
          </template>
        </TableDropdown>
        <div
          v-if="item.status !== 'void' && item.upload_payment_date && item.payment_image_list.length"
          class="text-caption"
        >
          {{ $t('uploadDatetime', { datetime: item.upload_payment_date }) }}
        </div>
      </template>
      <template v-slot:[`item.student_name`]="{ item }">
        <div class="d-flex align-center">
          <div style="white-space: nowrap;">{{ item.student_name }}</div>
          <v-btn
            v-if="canViewStudent"
            icon
            depressed
            x-small
            :to="{ name: 'StudentDetails', params: { id: item.student_id } }"
            :disabled="!item.student_active"
          >
            <v-icon class="fi fi-rr-eye" size="12" color="primary"></v-icon>
          </v-btn>
        </div>
      </template>

      <template slot="append-tool">
        <template v-if="enableBulkDownloadInvoice && !isStudent">
          <!-- 批量下載發票 -->
          <FormButton
            v-if="!$validate.DataValid(selectType) || selectType === 'invoice'"
            text="batchDownloadInvoices"
            outlined
            class="ml-4 mb-4"
            @click="handleBulkDownloadInvoiceClick('invoice')"
            color="darken-1"
          >
            <template slot="prepend">
              <v-icon class="fi-rr-cross mr-2" size="12" v-if="selectType === 'invoice'"></v-icon>
              <v-icon class="fi-rr-download mr-2" size="15" v-else></v-icon>
            </template>
          </FormButton>
          <!-- 批量下載收據 -->
          <FormButton
            v-if="!$validate.DataValid(selectType) || selectType === 'receipt'"
            text="batchDownloadReceipts"
            outlined
            class="ml-4 mb-4"
            @click="handleBulkDownloadInvoiceClick('receipt')"
            color="darken-1"
          >
            <template slot="prepend">
              <v-icon class="fi-rr-cross mr-2" size="12" v-if="selectType === 'receipt'"></v-icon>
              <v-icon class="fi-rr-download mr-2" size="15" v-else></v-icon>
            </template>
          </FormButton>
          <FormButton
            v-if="$validate.DataValid(selectType) && selectedTableRow.length > 0"
            :text="`${$t('table.download')} (${bulkDownloadCount})`"
            class="mb-4 ml-1"
            @click="submitBulkDownload()"
          />
          <FormButton
            v-if="$validate.DataValid(selectType) && selectedTableRow.length > 0"
            text="table.cancelAllSelect"
            class="mb-4 ml-1"
            color="error"
            @click="clearDownloadSelections()"
          />
        </template>
      </template>
      <template slot="append-toolbar-left">
        <FormSelect
          :fieldValue.sync="filter.status"
          :options="statusOptions"
          hideDetails
          placeholder="searchStatus"
          enableClear
          @changed="search()"
          class="mr-3 mt-2 mb-3 search-select-field"
          enableTooltip
          :readonly="tableLoading"
        />
      </template>
    </Datatable>

    <!-- Modal: 退款 -->
    <FormDialog ref="refundFormDialog" formRef="refundForm" title="refund">
      <v-row class="ma-0">
        <v-col cols="12" sm="6" md="4">
          <FormInput
            label="refundPrice"
            placeholder="refundPrice"
            :fieldValue.sync="refundData.price"
            required
            type="number"
            prefix="HK$"
            :customRules="[v => checkRefundAmount(v)]"
          />
        </v-col>
        <v-col cols="12" sm="6" md="4" v-if="refundOrderType.includes('package')">
          <FormInput
            label="refundLessonCount"
            placeholder="refundLessonCount"
            :fieldValue.sync="refundData.lesson_count"
            required
            type="number"
            isIntegerOnly
          />
        </v-col>
        <v-col cols="12" sm="6" md="4" v-if="!isAppMode(['T01'])">
          <FormSelect
            label="refundMethod"
            placeholder="refundMethod"
            :fieldValue.sync="refundData.payment_method"
            required
            :options="$paymentMethodOptions"
          />
        </v-col>

        <v-col cols="12" v-if="refundOrderType.includes('course') || refundOrderType.includes('product')">
          <label class="input-label">{{ $t('refundMarkLessonUnpaid') }}</label>
          <v-row class="ma-0 pa-0">
            <v-col cols="12" sm="6" md="4" class="ma-0 pa-0 pr-0 pr-sm-4">
              <FormSelect :fieldValue.sync="refundData.mark_unpaid" required :options="markUnpaidOptions" />
            </v-col>
          </v-row>

          <template v-if="refundData.mark_unpaid === true">
            <div class="input-label">{{ $t('refundItems') }}</div>
            <Datatable
              :tableData="refundTableData"
              :tableHeaders="refundTableHeaders"
              disablePagination
              enableSelectToggle
              :selectedTableRow.sync="refundData.items"
            />
          </template>
        </v-col>

        <v-col cols="12" sm="6" md="4">
          <FormInput label="remark" placeholder="remark" :fieldValue.sync="refundData.remark" />
        </v-col>
      </v-row>
    </FormDialog>

    <!-- Modal: 退款詳情 -->
    <DialogLayout ref="refundDetailsDialog" title="refund" hideAction>
      <v-row class="ma-0">
        <v-col cols="12" sm="6" md="4">
          <label class="input-label">{{ $t('refundPrice') }}</label>
          <div>HK${{ $formatter.separator(refundData.price) }}</div>
        </v-col>
        <v-col cols="12" sm="6" md="4" v-if="refundOrderType.includes('package')">
          <label class="input-label">{{ $t('refundLessonCount') }}</label>
          <div>{{ refundData.lesson_count }}</div>
        </v-col>
        <v-col cols="12" sm="6" md="4" v-if="!isAppMode(['T01'])">
          <label class="input-label">{{ $t('refundMethod') }}</label>
          <div>{{ refundData.payment_method ? $t(`paymentMethod.${refundData.payment_method}`) : '-' }}</div>
        </v-col>
        <v-col cols="12" v-if="refundTableData.length > 0">
          <div class="input-label">{{ $t('refundItems') }}</div>
          <Datatable :tableData="refundTableData" :tableHeaders="refundTableHeaders" disablePagination />
        </v-col>
        <v-col cols="12" sm="6" md="4">
          <label class="input-label">{{ $t('remark') }}</label>
          <div>{{ refundData.remark || '-' }}</div>
        </v-col>
        <v-col cols="12">
          <FormButton
            text="downloadRefund"
            @click="downloadRefundInvoice(refundData.order_id)"
            :loading="refundDownloading"
          />
        </v-col>
      </v-row>
    </DialogLayout>

    <!-- Modal: WhatsApp傳送連結 -->
    <FormDialog ref="selectWtsDialog" formRef="selectWtsForm" title="selectWhatsappPhone" :maxWidth="600">
      <v-row class="ma-0">
        <v-col cols="12">
          <v-radio-group
            name="selectWhatsappPhone"
            v-model="wtsPhone"
            class="ma-0"
            :rules="[v => this.$validate.required(v)]"
          >
            <v-radio
              v-for="(item, index) in wstPhoneOptions"
              :label="item.text"
              :value="item.value"
              :key="index"
            ></v-radio>
          </v-radio-group>
        </v-col>
      </v-row>
    </FormDialog>

    <!-- Modal: 修改 -->
    <FormDialog ref="editOrderDialog" formRef="editOrderForm" title="edit" :maxWidth="500">
      <v-row class="ma-0">
        <v-col class="pa-0 ma-0" cols="12" v-if="isAppMode(['DEV', 'T21'])">
          <FormInput
            label="customOrderCode"
            :fieldValue.sync="editOrderData.custom_invoice_number"
            :placeholder="editOrderData.order_code"
          />
        </v-col>

        <template v-if="!isAppMode(['T01'])">
          <v-col class="pa-0 ma-0 pr-1 mb-4" cols="8">
            <FormDatePicker
              label="createdDate"
              disableClear
              :dateValue.sync="editOrderData.order_create_date"
              required
              hideDetails
              disabledActionButtons
            />
          </v-col>
          <v-col class="pa-0 ma-0 mb-4" cols="4">
            <FormTimePicker
              :fieldValue.sync="editOrderData.order_create_time"
              :options="createTimeOptions"
              required
              style="margin-top: 26px"
              hideDetails
            />
          </v-col>
        </template>

        <template v-if="!editOrderData.is_redeem">
          <v-col class="pa-0 ma-0" cols="12">
            <FormSelect
              label="paymentSupport"
              :fieldValue.sync="editOrderData.payment_method"
              :options="$paymentMethodOptions"
              required
            />
          </v-col>
          <v-col class="pa-0 mb-8" cols="12" v-if="isAppMode(['T21']) && editOrderData.payment_method === 'cash'">
            <div class="d-flex align-center" v-if="editOrderData.sign">
              <FormButton text="viewEleSign" class="flex-grow-1" @click="viewImg(editOrderData.sign)" />
              <v-btn min-width="20" max-width="20" min-height="20" class="ml-2 primary" @click.prevent="openSignPad()">
                <v-icon class="fi fi-rr-pen-clip" size="18"></v-icon>
              </v-btn>
            </div>
            <FormButton v-else text="sign" block @click="openSignPad()">
              <template slot="prepend"><v-icon class="fi fi-rr-pen-clip mr-1" size="15"></v-icon></template>
            </FormButton>
          </v-col>
          <v-col class="pa-0 mb-8" cols="12">
            <FormUploader
              uploadText="uploadPaymentRecord"
              fileInputKey="upload_payment_order"
              :files.sync="editOrderData.paymentImages"
              dispatchUpdateOnChange
              :single="gDisableMultiplePaymentImg"
            />
          </v-col>
        </template>

        <v-col class="pa-0 ma-0" cols="12">
          <FormInput label="orderRemark" :fieldValue.sync="editOrderData.remark" />
        </v-col>
        <template v-if="!isAppMode(['T01'])">
          <v-col class="pa-0 ma-0" cols="12">
            <FormInput label="receiptRemark" :fieldValue.sync="editOrderData.pdf_remark" />
          </v-col>
          <template v-if="editOrderData.status === 'paid'">
            <v-col class="pa-0 ma-0 pr-1 mb-4" cols="8">
              <FormDatePicker
                label="paidDate"
                disableClear
                :dateValue.sync="editOrderData.pay_date"
                required
                hideDetails
                disabledActionButtons
              />
            </v-col>
            <v-col class="pa-0 ma-0 mb-4" cols="4">
              <FormTimePicker
                :fieldValue.sync="editOrderData.pay_time"
                :options="createTimeOptions"
                required
                style="margin-top: 26px"
                hideDetails
              />
            </v-col>
          </template>
        </template>
      </v-row>
    </FormDialog>
    <SignPad ref="signaturePadDialog" @confirm="editOrderData.sign = $event" />

    <!-- Modal: Log Record -->
    <DialogLayout ref="logDialog" title="logRecord" hideAction eager>
      <LogTable
        ref="logTableRef"
        :loading="logLoading"
        :tableData="logTableData"
        :total="logTableTotal"
        @options-update="getLogData()"
        hideTitle
      />
    </DialogLayout>
  </v-container>
</template>

<script>
import { mdiContentCopy, mdiWhatsapp } from '@mdi/js'
import Datatable from '@/components/Datatable.vue'
import ExcelMixin from '@/mixins/ExcelMixin.vue'
import FormDialog from '@/components/FormDialog.vue'
import FormInput from '@/components/formField/FormInput.vue'
import DialogLayout from '@/components/layout/DialogLayout.vue'
import FormSelect from '@/components/formField/FormSelect.vue'
import SignPad from '@/components/SignPad.vue'
import FormDatePicker from '@/components/formField/FormDatePicker.vue'
import FormTimePicker from '@/components/formField/FormTimePicker.vue'
import TableDropdown from '@/components/layout/TableDropdown.vue'
import FormUploader from '@/components/formField/FormUploader.vue'
import LogTable from '@/components/LogTable.vue'

export default {
  name: 'OrderList',
  inject: ['getConfirmDialogRef'],
  mixins: [ExcelMixin],
  components: {
    Datatable,
    FormDialog,
    FormInput,
    DialogLayout,
    FormSelect,
    SignPad,
    FormDatePicker,
    FormTimePicker,
    TableDropdown,
    FormUploader,
    LogTable,
  },
  computed: {
    confirmRef() {
      return this.getConfirmDialogRef()
    },
    sid() {
      return this.$validate.regexNumber(this.$route.params.sid) ? parseInt(this.$route.params.sid) : null
    },
    onlineCourseId() {
      return this.$validate.regexNumber(this.$route.params.cid) ? parseInt(this.$route.params.cid) : null
    },
    isStudent() {
      return this.userType === 'student'
    },
    refundTableHeaders() {
      let headers = [{ value: 'item_name', text: this.$t('purchaseItem'), width: 200 }]
      if (this.refundOrderType.includes('course')) {
        headers = [
          ...headers,
          { value: 'full_date', text: this.$t('date'), width: 145 }, // need 'date'
          { value: 'weekday', text: this.$t('weekday'), width: 100 },
          { value: 'timeslot', text: this.$t('time') },
        ]
      }

      if (this.refundOrderType.includes('product')) {
        headers.push({ value: 'qty', text: this.$t('quantity') })
      }

      return headers
    },
    tableHeaders() {
      const vm = this
      let headers = [
        { value: 'order_code', text: vm.$t('orderCode'), width: vm.isAppMode(['T21']) ? 250 : 100 },
        { value: 'create_date', text: vm.$t('createdDate'), width: 130 },
        { value: 'student_name', text: vm.$t('studentName'), width: 130 },
        ...(!this.gDisableStudentGrade ? [{ value: 'grade', text: vm.$t('grade'), width: 100 }] : []),
        { value: 'order_type', text: vm.$t('orderType'), width: 120 },
        { value: 'order_items', text: vm.$t('item'), width: 300 },
        { value: 'qty', text: vm.$t('quantity') },
        { value: 'total_price', text: vm.$t('totalPrice'), width: 150 },
      ]

      if (!this.isStudent) {
        headers.push({ value: 'remark', text: vm.$t('orderRemark'), width: 200 })

        if (!this.isAppMode(['T01'])) {
          headers.push({ value: 'staff_name', text: vm.$t('responsePerson') })
        }
      }
      headers.push({ value: 'status', text: vm.$t('status'), width: 350, align: 'end' })
      return headers
    },
    searchTypeOptions() {
      const vm = this
      if (this.isAppMode(['T01'])) {
        return [
          { value: 'student_name', text: vm.$t('studentName') },
          { value: 'order_id', text: vm.$t('orderCode') },
          { value: 'phone', text: vm.$t('phone') },
        ]
      } else {
        return [
          { value: 'student', text: vm.$t('studentNamePhoneCode') },
          { value: 'order_id', text: vm.$t('orderCode') },
        ]
      }
    },

    // permission & setting
    canAdvancedEditOrder() {
      return this.$validate.allowAction('advancedEditOrder', this.userType)
    },
    canEditOrder() {
      return this.$validate.allowAction('editOrder', this.userType)
    },
    disabledMultiTypeSearch() {
      return this.isStudent || this.sid !== null
    },
    enableBulkDownloadInvoice() {
      return !this.isAppMode(['T01'])
    },
    canViewLog() {
      return this.gEnableLog && this.$validate.allowAction('viewLog', this.userType)
    },
    canViewStudent() {
      return this.$validate.allowAction('StudentDetails', this.userType)
    },
  },
  data: vm => ({
    userType: vm.gfGetUserType(),
    tableLoading: false,
    tableData: [],
    tableItemTotal: 0,
    filter: {
      limit: 10,
      page: 1,
      keyword: '',
      searchType: '',
      date: '',
      dateRange: [],
      status: '',
    },

    exportLoading: false,
    exportTimeOut: null,
    downloadLoading: false,
    bulkDownloading: false,
    bulkDownloadCount: '',

    refundData: {
      price: '',
      items: [],
      remark: '',
      lesson_count: '',
      order_id: -1,
      mark_unpaid: false,
      payment_method: '',
    },
    refundOrderType: [],
    refundTableData: [],
    refundDownloading: false,

    wtsPhone: '',
    wstPhoneOptions: [],

    editOrderData: {
      is_redeem: false,
      payment_method: '',
      paymentImages: [],
      remark: '',
      sign: '',
      pdf_remark: '',
      order_create_date: '',
      order_create_time: '',
      pay_date: '',
      pay_time: '',
      status: '',
      order_code: '',
      custom_invoice_number: '',
    },
    createTimeOptions: [],

    selectType: '', // invoice
    enableSelect: false,
    selectedTableRow: [],

    logLoading: false,
    logTableData: [],
    logTableTotal: 0,
    logOrderId: -1,

    // --- static data
    markUnpaidOptions: [
      { value: true, text: vm.$t('true') },
      { value: false, text: vm.$t('refundOnly') },
    ],
    statusOptions: [
      { value: 'pending', text: vm.$t('orderStatusOption.pending') },
      { value: 'paid', text: vm.$t('orderStatusOption.paid') },
      { value: 'processing', text: vm.$t('orderStatusOption.processing') },
      { value: 'debit', text: vm.$t('orderStatusOption.debit') },
      { value: 'void', text: vm.$t('orderStatusOption.void') },
    ],
    icon: {
      mdiContentCopy,
      mdiWhatsapp,
    },
  }),
  methods: {
    async getOrderData(regenUrl = true) {
      if (regenUrl === true) {
        this._regenerateURL()
      }

      this.tableLoading = true
      try {
        const payload = await this._getPayload()
        const { data, total } = await this.$Fetcher.GetOrders(payload)

        const list = await this._getOrderPackages(data)
        this.tableData = list.map(this.gfParseOrderData)
        this._updateDataDisabled()
        this.tableItemTotal = total
        this.tableLoading = false

        await this._getOrderCode()
        this._getOrderStaff()
        this.$common.logData(this.tableData, 'Orders')
      } catch (err) {
        this.$common.error(err)
        this.tableLoading = false
        this.tableData = []
        if (this.filter.page === 1) {
          this.tableItemTotal = 0
        }
      }
    },
    async _getPayload() {
      let payload = {
        filter_limit: this.filter.limit,
        filter_page: this.filter.page - 1,
        filter_item: [],
      }

      if (this.isStudent) {
        const userData = this.gfGetCurrentUserData()
        payload['filter_item'].push({ key: 'student_id', value: userData.id })
      } else {
        if (this.sid !== null) {
          payload['filter_item'].push({ key: 'student_id', value: this.sid })
        }
        if (this.onlineCourseId !== null) {
          payload['filter_item'].push({ key: 'online_course_id', value: this.onlineCourseId })
        }

        if (!this.isAppMode(['T21']) && this.sid === null && this.onlineCourseId === null) {
          const selectedSchool = this.gfGetUserSelectedSchool()
          if (selectedSchool > -1) {
            payload['center_id'] = selectedSchool
          }
        }
      }

      if (this.$validate.DataValid(this.filter.keyword)) {
        const keyword = this.filter.keyword.trim()

        if (this.disabledMultiTypeSearch || this.filter.searchType === 'order_id') {
          if (this.$validate.regexId(keyword)) {
            const id = keyword.substring(1)
            payload['filter_item'].push({ key: 'id', value: parseInt(id) })
          } else if (this.$validate.regexNumber(keyword)) {
            payload['filter_item'].push({ key: 'id', value: parseInt(keyword) })
          }
        } else if (this.filter.searchType === 'student') {
          payload['search'] = keyword
        } else {
          payload['filter_item'].push({ key: this.filter.searchType, value: keyword })
        }
      }

      if (this.isAppMode(['T01']) && this.$validate.DataValid(this.filter.date)) {
        payload['date'] = this.filter.date
        payload['filter_item'].push({ key: 'create_date', value: this.filter.date })
      } else if (this.$validate.DataValid(this.filter.dateRange, true)) {
        if (this.filter.dateRange.length === 1) {
          payload['date'] = this.filter.dateRange[0]
          payload['filter_item'].push({ key: 'create_date', value: this.filter.dateRange[0] })
        } else {
          payload['filter_item'].push({ key: 'start_date', value: this.filter.dateRange[0] })
          if (this.filter.dateRange.length > 1) {
            payload['filter_item'].push({ key: 'end_date', value: this.filter.dateRange[1] })
          }
        }
      }

      if (this.$validate.DataValid(this.filter.status)) {
        payload['filter_item'].push({ key: 'status', value: this.filter.status })
      }

      return payload
    },
    _getOrderPackages(list) {
      return new Promise(async (resolve, reject) => {
        const noDataPackages = []

        list.forEach(item => {
          for (let i = 0; i < item.package_list.length; i++) {
            const found = item.package_datas.find(el => el.id === item.package_list[i].id)
            if (!found) {
              noDataPackages.push(item.package_list[i].id)
            }
          }
        })
        if (noDataPackages.length) {
          try {
            const data = await this.$Fetcher.GetPackagesByIdList(noDataPackages)
            list.forEach(item => {
              for (let i = 0; i < item.package_list.length; i++) {
                const found = item.package_datas.find(el => el.id === item.package_list[i].id)
                if (!found) {
                  const foundPackage = data.find(el => el.id === item.package_list[i].id)
                  if (foundPackage) {
                    item.package_datas.push(foundPackage)
                  }
                }
              }
            })
            resolve(list)
          } catch (err) {
            this.$common.error(err)
            if (err === 'abort') {
              reject(err)
            } else {
              resolve(list)
            }
          }
        } else {
          resolve(list)
        }
      })
    },
    async _getOrderCode(count = 0) {
      if (count < this.tableData.length) {
        const orderCode = await this.gfGenerateOrderId(this.tableData[count])
        if (orderCode !== 'abort') {
          this.$set(this.tableData[count], 'order_code', orderCode)
          count += 1
          await this._getOrderCode(count)
        }
      }
    },
    async _getOrderStaff() {
      let ids = this.tableData.map(el => el.staff_id)
      ids = ids.filter(el => el > -1)
      if (ids.length) {
        try {
          const data = await this.$Fetcher.GetStaffsByIdList(ids)
          for (let i = 0; i < this.tableData.length; i++) {
            if (this.tableData[i].staff_id > -1) {
              const found = data.find(el => el.id === this.tableData[i].staff_id)
              if (found) {
                this.$set(this.tableData[i], 'staff_name', found.name)
              } else {
                this.$set(this.tableData[i], 'staff_name', this.tableData[i].staff_id)
              }
            }
          }
        } catch {}
      }
    },
    clearFilter() {
      this.filter.page = 1
      this.filter.keyword = ''
      this.filter.searchType = this.disabledMultiTypeSearch ? 'order_id' : this.searchTypeOptions[0].value
      this.filter.date = ''
      this.filter.status = ''
    },
    search() {
      this.filter.page = 1
      this.tableItemTotal = 0
      this.getOrderData()
    },
    searchKeyword(keyword) {
      this.filter.keyword = keyword.trim()
      this.search()
    },
    searchOrderDate(date) {
      this.filter.date = date
      this.search()
    },
    searchOrderDateRange(date) {
      this.filter.dateRange = date
      this.search()
    },
    clearSearch() {
      this.clearFilter()
      this.tableItemTotal = 0
      this.getOrderData()
    },
    refreshData() {
      this.filter.limit = 10
      this.filter.page = 1
      this.tableItemTotal = 0
      this.getOrderData()
    },

    _getQuery() {
      this.clearFilter()
      this.filter.limit = 10
      const query = this.gfGetTableQuery({
        searchType: 'string',
        search: 'string',
        page: 'int',
        limit: 'int',
        status: 'string',
        date: 'date',
      })
      for (const key in this.filter) {
        if (key === 'keyword') {
          if (this.$validate.DataValid(query['search'])) {
            this.$set(this.filter, key, query['search'])
          }
        } else if (this.$validate.DataValid(query[key])) {
          this.$set(this.filter, key, query[key])
        }
      }
    },
    _regenerateURL() {
      const q = {
        searchType: this.disabledMultiTypeSearch ? 'order_id' : this.filter.searchType,
        search: this.filter.keyword.trim(),
        date: this.filter.date,
        page: this.filter.limit !== 10 || this.filter.page !== 1 ? this.filter.page : null,
        limit: this.filter.limit !== 10 || this.filter.page !== 1 ? this.filter.limit : null,
        status: this.filter.status,
      }
      const newQuery = this.$common.diffQuery(q, this.$route.query)
      if (newQuery) this.$router.replace({ query: newQuery })
    },

    viewImg(img) {
      if (img.indexOf('data:image') > -1) {
        this.$store.dispatch('openMediaPopup', { media: img })
      } else {
        this.$store.dispatch('openMediaPopup', { media: `${this.$mediaPath}${img}` })
      }
    },

    // ========== 匯出報表 ==========
    async exportData(prePayload = null, count = 0) {
      if (this.isStudent) return
      if (this.exportLoading || this.downloadLoading || this.bulkDownloading) {
        this.$store.dispatch('toggleSnack', { message: 'processing' })
        return
      }

      this.exportLoading = true
      let payload = {}
      if (prePayload) {
        payload = prePayload
      } else {
        if (this.$validate.DataValid(this.filter.date)) {
          payload['start_date'] = this.filter.date
          payload['end_date'] = this.filter.date
        }
        if (this.sid !== null) {
          payload['student_id'] = this.sid
        } else if (this.$validate.DataValid(this.filter.searchType) && this.$validate.DataValid(this.filter.keyword)) {
          const student = await this._getStudentByFilter()
          if (student) {
            payload['student_id'] = student.id
          }
        }

        if (this.onlineCourseId !== null) {
          payload['online_course_id'] = this.onlineCourseId
        }

        if (!this.isAppMode(['T21']) && this.sid === null && this.onlineCourseId === null) {
          const selectedSchool = this.gfGetUserSelectedSchool()
          if (selectedSchool > -1) {
            payload['center_id'] = selectedSchool
          }
        }
      }

      try {
        const file = await this.$Fetcher.ExportOrderReport(payload)

        var download = document.createElement('a')
        download.download = file
        download.href = `${this.$reportPath}${file}`
        download.style.display = 'none'
        download.target = '_blank'
        document.body.appendChild(download)
        download.click()
        download.remove()

        if (this.exportTimeOut !== null) {
          clearTimeout(this.exportTimeOut)
        }
        this.exportLoading = false
      } catch (err) {
        this.$common.error(err)
        if (err !== 'abort') {
          if (count < 5) {
            this.exportTimeOut = setTimeout(async () => {
              this.exportLoading = false
              count++
              await this.exportData(payload, count)
            }, 100)
          } else {
            this.showAlert({
              title: 'message.exportFail',
              message: err,
              isError: true,
            })
            if (this.exportTimeOut !== null) {
              clearTimeout(this.exportTimeOut)
            }
            this.exportLoading = false
          }
        } else {
          if (this.exportTimeOut !== null) {
            clearTimeout(this.exportTimeOut)
          }
          this.exportLoading = false
        }
      }
    },
    _getStudentByFilter() {
      return new Promise(async (resolve, reject) => {
        try {
          let payload = {
            filter_limit: 1,
            filter_page: 0,
            filter_item: [],
          }
          if (this.filter.searchType === 'student_name') {
            payload['filter_item'].push({ key: 'name', value: this.filter.keyword })
          } else if (this.filter.searchType === 'phone') {
            payload['filter_item'].push({ key: 'phone', value: this.filter.keyword })
          } else if (this.filter.searchType === 'student') {
            payload['search'] = this.filter.keyword
          }
          if (payload.filter_item.length || payload['search']) {
            const { data, total } = await this.$Fetcher.GetStudents(payload)
            if (total === 1) {
              resolve(data[0])
            } else {
              resolve(null)
            }
          } else {
            resolve(null)
          }
        } catch (err) {
          resolve(null)
        }
      })
    },

    // ========== 檢視付款記錄 ==========
    viewPaymentRecordImg(img) {
      const list = img.map(file => {
        if (file.indexOf('data:image') > -1) {
          return file
        } else {
          return `${this.$mediaPath}${file}`
        }
      })
      if (list.length) {
        this.$store.dispatch('openMediaPopup', { media: list })
      }
    },

    // ============ 下載收據 ============
    async _getReceiptFile(orderId, regen = false) {
      if (this.isAppMode(['T01'])) regen = true

      try {
        let file = ''

        if (!regen) {
          const found = this.tableData.find(el => el.id === orderId)
          if (found && found.receipt_pdf) {
            const confirmRegen = await this.confirmRef.show({
              message: 'message.regenReceipt',
              confirmBtnText: 'need',
              cancelBtnText: 'noNeed',
            })

            if (confirmRegen) {
              regen = true
            } else {
              file = found.receipt_pdf
            }
          }
        }

        if (!file) {
          file = await this._genReceiptFile(orderId, regen)
          for (let i = 0; i < this.tableData.length; i++) {
            if (this.tableData[i].id === orderId) {
              this.$set(this.tableData[i], 'receipt_pdf', file)
              break
            }
          }
        }

        return file
      } catch (err) {
        this.$common.error(err)
        if (err !== 'abort') {
          this.showAlert({
            title: 'message.downloadFail',
            message: err,
            isError: true,
          })
        }

        return ''
      }
    },
    _genReceiptFile(orderId, regen = false) {
      return new Promise(async (resolve, reject) => {
        try {
          const file = await this.$Fetcher.ExportOrderReceipt(orderId, regen)
          for (let i = 0; i < this.tableData.length; i++) {
            if (this.tableData[i].id === orderId) {
              this.$set(this.tableData[i], 'receipt_pdf', file)
              break
            }
          }
          resolve(file)
        } catch (err) {
          this.$common.error(err)
          reject(err)
        }
      })
    },
    // -- (下載收據)
    async exportReceipt(orderId, regen = false) {
      if (this.$store.getters.isLoading || this.exportLoading || this.downloadLoading || this.bulkDownloading) {
        this.$store.dispatch('toggleSnack', { message: 'processing' })
        return
      }

      this.downloadLoading = true
      const file = await this._getReceiptFile(orderId, regen)
      if (this.$validate.DataValid(file)) {
        var download = document.createElement('a')
        download.download = file
        download.href = this.gfGetDownloadPDFLink(file)
        download.style.display = 'none'
        download.target = '_blank'
        document.body.appendChild(download)
        download.click()
        download.remove()
      }
      this.downloadLoading = false
    },
    // -- (複製收據連結)
    async copyReceiptLink(orderId) {
      if (this.$store.getters.isLoading || this.exportLoading || this.downloadLoading || this.bulkDownloading) {
        this.$store.dispatch('toggleSnack', { message: 'processing' })
        return
      }

      const vm = this
      const getUrl = new Promise(async (resolve, reject) => {
        vm.downloadLoading = true
        const file = await vm._getReceiptFile(orderId)
        vm.downloadLoading = false
        if (this.$validate.DataValid(file)) {
          resolve(`${vm.$mediaPath}${file}`)
        } else {
          reject('')
        }
      })
      this.gfCopyText(getUrl)
    },

    // ============ 下載發票 ============
    _genInvoiceFile(orderId, regen = false) {
      return new Promise(async (resolve, reject) => {
        try {
          const file = await this.$Fetcher.ExportOrderInvoice(orderId, regen)
          for (let i = 0; i < this.tableData.length; i++) {
            if (this.tableData[i].id === orderId) {
              this.$set(this.tableData[i], 'invoice_pdf', file)
              break
            }
          }
          resolve(file)
        } catch (err) {
          this.$common.error(err)
          reject(err)
        }
      })
    },

    async exportInvoice(orderId, regen = false) {
      if (this.exportLoading || this.downloadLoading || this.bulkDownloading) {
        this.$store.dispatch('toggleSnack', { message: 'processing' })
        return
      }

      if (this.isAppMode(['T01'])) regen = true

      this.downloadLoading = true
      try {
        let file = ''
        if (!regen) {
          const found = this.tableData.find(el => el.id === orderId)
          if (found && found.invoice_pdf) {
            const confirmRegen = await this.confirmRef.show({
              message: 'message.regenInvoice',
              confirmBtnText: 'need',
              cancelBtnText: 'noNeed',
            })
            if (confirmRegen) {
              regen = true
            } else {
              file = found.invoice_pdf
            }
          }
        }
        if (!file) {
          file = await this._genInvoiceFile(orderId, regen)
        }

        var download = document.createElement('a')
        download.download = file
        download.href = this.gfGetDownloadPDFLink(file)
        download.style.display = 'none'
        download.target = '_blank'
        document.body.appendChild(download)
        download.click()
        download.remove()

        this.downloadLoading = false
      } catch (err) {
        this.$common.error(err)
        if (err !== 'abort') {
          this.showAlert({
            title: 'message.downloadFail',
            message: err,
            isError: true,
          })
        }

        this.downloadLoading = false
      }
    },

    // ============== 批量下載發票/收據 ==============
    handleBulkDownloadInvoiceClick(type) {
      if (this.exportLoading || this.downloadLoading || this.bulkDownloading) {
        this.$store.dispatch('toggleSnack', { message: 'processing' })
        return
      }
      this.selectedTableRow = []
      if (this.$validate.DataValid(this.selectType)) {
        this.selectType = ''
        this.enableSelect = false
      } else {
        this.enableSelect = true
        this.selectType = type
      }
      this._updateDataDisabled()
    },
    async submitBulkDownload() {
      if (this.exportLoading || this.downloadLoading || this.bulkDownloading) {
        this.$store.dispatch('toggleSnack', { message: 'processing' })
        return
      }

      if (this.selectedTableRow.length < 1) {
        this.$store.dispatch('toggleSnack', { type: 'error', message: 'message.atLeastOneOrder' })
        return
      }

      this.selectedTableRow.sort((a, b) => b.id - a.id)

      this.bulkDownloading = true
      this.selectedTableRow = this.selectedTableRow.filter(el => !el.disabled)

      this.bulkDownloadCount = `0/${this.selectedTableRow.length}`

      try {
        let files = []
        if (this.selectType === 'invoice') {
          const res = await this._genInvoiceOneByOne()
          if (res[0] !== true) throw res[1]
          files = res[1]
        } else if (this.selectType === 'receipt') {
          const res = await this._genReceiptOneByOne()
          if (res[0] !== true) throw res[1]
          files = res[1]
        } else {
          throw 'message.errorOccur'
        }

        if (!this.$validate.DataValid(files, true)) throw 'message.errorOccur'

        const confirm = await this.confirmRef.show({
          message: 'message.zipFiles',
          confirmBtnText: 'need',
          cancelBtnText: 'noNeed',
        })
        if (confirm) {
          const zip = await this.$Fetcher.ZipFiles(files)
          var download = document.createElement('a')
          download.download = zip
          download.href = `${this.$mediaPath}${zip}`
          download.style.display = 'none'
          download.target = '_blank'
          document.body.appendChild(download)
          download.click()
          download.remove()
        } else {
          this._downloadPDFOneByOne(files)
        }

        this.bulkDownloading = false
      } catch (err) {
        this.$common.error(err)
        if (err !== 'abort') {
          this.showAlert({
            title: 'message.downloadFail',
            message: err,
            isError: true,
          })
        }
        this.bulkDownloading = false
      }
    },
    async _genInvoiceOneByOne(list = [], count = 0) {
      if (count < this.selectedTableRow.length) {
        try {
          if (this.selectedTableRow[count].invoice_pdf) {
            list.push(this.selectedTableRow[count].invoice_pdf)
          } else {
            const file = await this._genInvoiceFile(this.selectedTableRow[count].id, false)
            list.push(file)
          }

          count += 1
          this.bulkDownloadCount = `${count}/${this.selectedTableRow.length}`
          return await this._genInvoiceOneByOne(list, count)
        } catch (err) {
          this.$common.error(err)
          return [false, err]
        }
      } else {
        this.bulkDownloadCount = `${count}/${this.selectedTableRow.length}`
        return [true, list]
      }
    },
    async _genReceiptOneByOne(list = [], count = 0) {
      if (count < this.selectedTableRow.length) {
        try {
          if (this.selectedTableRow[count].receipt_pdf) {
            list.push(this.selectedTableRow[count].receipt_pdf)
          } else {
            const file = await this._genReceiptFile(this.selectedTableRow[count].id, false)
            list.push(file)
          }

          count += 1
          this.bulkDownloadCount = `${count}/${this.selectedTableRow.length}`
          return await this._genReceiptOneByOne(list, count)
        } catch (err) {
          this.$common.error(err)
          return [false, err]
        }
      } else {
        this.bulkDownloadCount = `${count}/${this.selectedTableRow.length}`
        return [true, list]
      }
    },
    _downloadPDFOneByOne(files, count = 0) {
      if (count < files.length) {
        var download = document.createElement('a')
        download.download = files[count]
        download.href = this.gfGetDownloadPDFLink(files[count])
        download.style.display = 'none'
        download.target = '_blank'
        document.body.appendChild(download)
        download.click()
        download.remove()

        count += 1
        this._downloadPDFOneByOne(files, count)
      }
    },

    clearDownloadSelections() {
      if (this.bulkDownloading) {
        this.$store.dispatch('toggleSnack', { message: 'processing' })
        return
      }
      this.selectedTableRow = []
    },
    onBulkDownloadRowChanged() {
      if (!this.bulkDownloading) {
        this.selectedTableRow = this.selectedTableRow.filter(el => !el.disabled)
        this.bulkDownloadCount = this.selectedTableRow.length
      }
    },
    _updateDataDisabled() {
      for (let i = 0; i < this.tableData.length; i++) {
        this.$set(this.tableData[i], 'disabled', false)
        if (
          this.tableData[i].status === 'void' ||
          (this.selectType === 'receipt' && this.tableData[i].status !== 'paid' && this.tableData[i].status !== 'debit')
        ) {
          this.$set(this.tableData[i], 'disabled', true)
        }
      }
    },

    // ============== 退款 ==============
    // 未退款 用
    async handleRefund(orderId, newOpen = true) {
      if (newOpen) {
        this.refundData.order_id = -1
        this.refundData.price = ''
        this.refundData.items = []
        this.refundData.remark = ''
        this.refundData.lesson_count = ''
        this.refundData.payment_method = ''
        this.refundOrderType = []
        await this.$refs.refundFormDialog.resetForm()
        this.refundData.mark_unpaid = false

        const found = this.tableData.find(el => el.id === orderId)
        if (found) {
          this.refundTableData = []
          this.refundOrderType = found.order_type

          let count = 0
          if (this.refundOrderType.includes('course')) {
            found.lesson_list.forEach(item => {
              const target = found.lesson_datas.find(el => el.id === item.id)
              if (target) {
                this.refundTableData.push({
                  id: count,
                  item_id: item.id,
                  item_name: target?.course_name || '',
                  start_time: target?.start_time || '',
                  end_time: target?.end_time || '',
                  date: target?.date || '',
                  type: 'course',
                })
              }

              count += 1
            })
          }

          if (this.refundOrderType.includes('product')) {
            found.product_list.forEach(item => {
              const target = found.product_datas.find(el => el.id === item.id)
              this.refundTableData.push({
                id: count,
                item_id: item.id,
                qty: item.amount,
                item_name: target?.name || '',
                type: 'product',
              })

              count += 1
            })
          }

          this.$refs.refundFormDialog.setInfo(orderId)
        } else {
          return
        }
      } else {
        this.$refs.refundFormDialog.setLoading(false)
      }

      const confirm = await this.$refs.refundFormDialog.show()
      if (confirm) {
        const confirmRefund = await this.confirmRef.show({
          title: 'message.confirmRefund',
          message: 'message.confirmRefundMsg',
        })
        if (!confirmRefund) {
          this.handleRefund(orderId, false)
          return
        }

        // reject if mark_unpaid = true & NO selected item
        if (
          (this.refundOrderType.includes('course') || this.refundOrderType.includes('product')) &&
          this.refundData.mark_unpaid &&
          this.refundData.items.length < 1
        ) {
          this.showAlert({
            title: 'message.operationalError',
            message: 'message.atLeastOneItem',
            isError: true,
          })
          this.handleRefund(orderId, false)
          return
        }

        // -- reject if 唔夠package quota退
        if (this.refundOrderType.includes('package')) {
          const targetOrder = this.tableData.find(el => el.id === orderId)
          if (targetOrder) {
            const packageQuota = await this.$Fetcher.GetStudentPackageQuota(targetOrder.student_id)
            if (packageQuota <= 0 || packageQuota < parseInt(this.refundData.lesson_count)) {
              this.showAlert({
                title: 'message.refundFail',
                message: 'message.noMorePackageQuotaInRefund',
                isError: true,
              })
              this.handleRefund(orderId, false)
              return
            }
          } else {
            this.handleRefund(orderId, false)
            return
          }
        }

        try {
          // --------- payload ---------
          let payload = {
            amount: parseFloat(this.refundData.price),
            package_count: 0,
            lesson_ids: [],
            product_ids: [],
            debit_remark: this.refundData.remark,
            debit_payment_method: this.refundData.payment_method,
          }
          const refundItemIds = this.refundData.items.map(el => el.id)
          const refundItems = this.refundTableData.filter(el => refundItemIds.includes(el.id))

          if (this.refundOrderType.includes('package')) {
            payload['package_count'] = parseInt(this.refundData.lesson_count)
          } else if (this.refundOrderType.includes('course') && this.refundData.mark_unpaid) {
            const refundLessons = refundItems.filter(el => el.type === 'course')
            payload['lesson_ids'] = refundLessons.map(el => el.item_id)
          }

          if (this.refundOrderType.includes('product') && this.refundData.mark_unpaid) {
            const refundProducts = refundItems.filter(el => el.type === 'product')
            payload['product_ids'] = refundProducts.map(el => {
              return { id: el.item_id, amount: el.qty }
            })
          }
          // ------- End of payload -------

          await this.$Fetcher.RefundOrder(orderId, payload)
          this.$store.dispatch('toggleSnack', {
            message: 'message.refundSuccess',
            type: 'success',
          })
          this.$refs.refundFormDialog.hide()
          this.getOrderData(false)
        } catch (err) {
          this.showAlert({
            title: 'message.refundFail',
            message: err,
            isError: true,
          })
          this.handleRefund(orderId, false)
        }
      }
    },
    checkRefundAmount(value) {
      const n = parseFloat(value)
      if (isNaN(n)) return false
      if (this.$refs && this.$refs.refundFormDialog) {
        const orderId = this.$refs.refundFormDialog.getInfo()

        const targetOrder = this.tableData.find(el => el.id === orderId)

        if (targetOrder && n > targetOrder.subtotal) {
          return this.$t('message.refundAmountExceedOrderTotal')
        }
      }

      return true
    },

    // 已退款 用
    openRefundDetails(orderId) {
      this.refundData.order_id = -1
      this.refundData.price = ''
      this.refundData.items = []
      this.refundData.remark = ''
      this.refundData.lesson_count = ''
      this.refundData.payment_method = ''
      this.refundOrderType = ''

      const found = this.tableData.find(el => el.id === orderId)
      if (found) {
        this.refundData.order_id = found.id
        this.refundTableData = []
        this.refundOrderType = found.order_type

        let count = 0
        if (this.refundOrderType.includes('course')) {
          found.debit_lesson_ids.forEach(lessonId => {
            const target = found.lesson_datas.find(el => el.id === lessonId)
            this.refundTableData.push({
              id: count,
              item_id: lessonId,
              item_name: target?.course_name || '',
              start_time: target?.start_time || '',
              end_time: target?.end_time || '',
              date: target?.date || '',
              type: 'course',
            })

            count += 1
          })
        }

        if (this.refundOrderType.includes('product')) {
          found.debit_product_ids.forEach(item => {
            const target = found.product_datas.find(el => el.id === item.id)
            this.refundTableData.push({
              id: count,
              item_id: item.id,
              qty: item.amount,
              item_name: target?.name || '',
              type: 'product',
            })

            count += 1
          })
        }

        this.refundData.price = found.debit_amount
        this.refundData.remark = found.debit_remark
        this.refundData.lesson_count = found.debit_package_count
        this.refundData.payment_method = found.debit_payment_method
        this.$refs.refundDetailsDialog.show()
      }
    },
    // -- (下載退款收據)
    async downloadRefundInvoice(order_id) {
      if (this.refundDownloading) {
        this.$store.dispatch('toggleSnack', { message: 'processing' })
        return
      }

      const found = this.tableData.find(el => el.id === order_id)
      if (found) {
        this.refundDownloading = true
        try {
          let filename = ''
          if (this.$validate.DataValid(found.debit_pdf_file)) {
            filename = found.debit_pdf_file
          } else {
            const data = await this.$Fetcher.GetSchoolById(found.school_id)
            filename = `tutoring_debit_${data.school_code}-${this.$formatter.pad(order_id, 4)}.pdf`
          }

          if (filename) {
            var download = document.createElement('a')
            download.download = filename
            download.href = this.gfGetDownloadPDFLink(filename)
            download.style.display = 'none'
            download.target = '_blank'
            document.body.appendChild(download)
            download.click()
            download.remove()
          }
        } catch (err) {
          this.$common.error(err)
          if (err !== 'abort') {
            this.$store.dispatch('toggleSnack', {
              message: 'message.downloadFail',
              type: 'error',
            })
          }
        } finally {
          this.refundDownloading = false
        }
      }
    },

    // ============= 作廢發票 =============
    async handleVoidOrder(orderId) {
      if (this.$store.getters.isLoading) {
        this.$store.dispatch('toggleSnack', { message: 'processing' })
        return
      }

      const confirm = await this.confirmRef.show({
        title: 'message.confirmVoid',
        message: 'message.confirmVoidMsg',
      })
      if (confirm) {
        if(this.isAppMode(['DEV','UAT'])){
          const quitConfirm = await this.confirmRef.show({
            title: 'message.quitAfterLesson',
            message: 'message.quitAfterLessonMsg',
            cancelBtnText: 'message.notQuitText',
            confirmBtnText: 'message.quitText',
          })
          if (quitConfirm) {
            this.$store.dispatch('setLoading', true)
            try {
              await this.$Fetcher.VoidOrder(orderId, true)
              this.$store.dispatch('setLoading', false)
              this.$store.dispatch('toggleSnack', {
                message: 'message.voidSuccess',
                type: 'success',
              })
              this.getOrderData(false)
            } catch (err) {
              this.$store.dispatch('setLoading', false)
              this.showAlert({
                title: 'message.voidFail',
                message: err,
                isError: true,
              })
            }
          }else{
            this.$store.dispatch('setLoading', true)
            try {
              await this.$Fetcher.VoidOrder(orderId)
              this.$store.dispatch('setLoading', false)
              this.$store.dispatch('toggleSnack', {
                message: 'message.voidSuccess',
                type: 'success',
              })
              this.getOrderData(false)
            } catch (err) {
              this.$store.dispatch('setLoading', false)
              this.showAlert({
                title: 'message.voidFail',
                message: err,
                isError: true,
              })
            }
          }

        }else{
          this.$store.dispatch('setLoading', true)
          try {
            await this.$Fetcher.VoidOrder(orderId)
            this.$store.dispatch('setLoading', false)
            this.$store.dispatch('toggleSnack', {
              message: 'message.voidSuccess',
              type: 'success',
            })
            this.getOrderData(false)
          } catch (err) {
            this.$store.dispatch('setLoading', false)
            this.showAlert({
              title: 'message.voidFail',
              message: err,
              isError: true,
            })
          }
        }
      }
    },

    // ============= 審核付款 =============
    async handleApproveOrder(orderId) {
      if (this.$store.getters.isLoading) {
        this.$store.dispatch('toggleSnack', { message: 'processing' })
        return
      }

      const confirm = await this.confirmRef.show({
        title: 'message.confirmApproveOrder',
        message: 'message.confirmApproveOrderMsg',
      })
      if (confirm) {
        this.$store.dispatch('setLoading', true)

        try {
          const getUser = this.gfGetCurrentUserData()

          await this.$Fetcher.UpdateOrder(orderId, {
            status: 'paid',
            approver_id: getUser.id,
          })
          this.$store.dispatch('setLoading', false)
          this.$store.dispatch('toggleSnack', {
            message: 'message.saveSuccess',
            type: 'success',
          })
          this.getOrderData(false)
        } catch (err) {
          this.$store.dispatch('setLoading', false)
          this.showAlert({
            title: 'message.saveFail',
            message: err,
            isError: true,
          })
        }
      }
    },

    // =========== 複製付款連結 ===========
    _getPaymentLink(centerId, orderId) {
      return new Promise(async (resolve, reject) => {
        try {
          const data = await this.$Fetcher.GetOrderPaymentLink(centerId, orderId)
          if (this.$validate.DataValid(this.$config.VUE_APP_PAYMENT_LINK_DOMAIN)) {
            resolve(`${this.$config.VUE_APP_PAYMENT_LINK_DOMAIN}/${data}`)
          } else {
            resolve('')
          }
        } catch (err) {
          this.$common.error(err)
          resolve('')
        }
      })
    },
    async copyPaymentLink(orderId) {
      if (this.$store.getters.isLoading) {
        this.$store.dispatch('toggleSnack', { message: 'processing' })
        return
      }

      const found = this.tableData.find(el => el.order_id === orderId)
      if (!found) return

      this.$store.dispatch('setLoading', true)

      const vm = this
      const getUrl = new Promise(async (resolve, reject) => {
        const url = await vm._getPaymentLink(found.school_id, orderId)
        resolve(url)
      })
      this.gfCopyText(getUrl)

      this.$store.dispatch('setLoading', false)
    },
    // -- (付款（for 學生 user）)
    async openPaymentLink(orderId) {
      if (this.$store.getters.isLoading) {
        this.$store.dispatch('toggleSnack', { message: 'processing' })
        return
      }
      const found = this.tableData.find(el => el.order_id === orderId)
      if (!found) return
      this.$store.dispatch('setLoading', true)
      await this.gfOpenWindow(async () => {
        const url = await this._getPaymentLink(found.school_id, orderId)
        return url
      })
      this.$store.dispatch('setLoading', false)
    },

    // ========= WhatsApp傳送連結 =========
    async handleSendWts(orderId, type, newOpen = true) {
      if (newOpen) {
        if (this.$store.getters.isLoading) {
          this.$store.dispatch('toggleSnack', { message: 'processing' })
          return
        }
        const found = this.tableData.find(el => el.order_id === orderId)
        if (!found) return
        this.wstPhoneOptions = []
        this.wtsPhone = ''

        // get phone options
        this.$store.dispatch('setLoading', true)
        try {
          const data = await this.$Fetcher.GetStudentById(found.student_id)
          for (let i = 0; i < data.whatsapp_data.length; i++) {
            this.wstPhoneOptions.push({
              value: i,
              data: data.whatsapp_data[i].phone,
              text: `${data.whatsapp_data[i].name} ${data.whatsapp_data[i].phone}`,
            })
          }
          if (this.wstPhoneOptions.length) {
            this.wtsPhone = this.wstPhoneOptions[0].value
          }

          this.$store.dispatch('setLoading', false)
        } catch (err) {
          this.$common.error(err)
          this.$store.dispatch('setLoading', false)
          if (err !== 'abort') {
            this.showAlert({
              title: 'message.saveFail',
              message: 'message.studentNotFound',
              isError: true,
            })
          }

          return
        }
      } else {
        this.$refs.selectWtsDialog.setLoading(false)
      }

      const confirm = await this.$refs.selectWtsDialog.show()
      if (confirm) {
        if (!this.$validate.DataValid(this.wtsPhone)) {
          this.$store.dispatch('toggleSnack', {
            message: 'message.noWtsPhone',
            type: 'error',
          })
          this.handleSendWts(orderId, type, false)
          return
        }

        const foundPhone = this.wstPhoneOptions.find(el => el.value === this.wtsPhone)
        if (type === 'paid') {
          await this.gfOpenWindow(async () => {
            this.downloadLoading = true
            const file = await this._getReceiptFile(orderId, true)
            this.downloadLoading = false
            const wtsMessage = this.$t('receiptLinkMsg')
            if (this.$validate.DataValid(file)) {
              this.$common.log('file >>> '+file);
              const safeFile = encodeURI(file);
              this.$common.log('safeFile >>> '+safeFile);
              return `https://api.whatsapp.com/send?phone=852${foundPhone.data}&text=${wtsMessage.replace(
                /(?:\r\n|\r|\n)/g,
                '%0A',
              )}%0A${this.$mediaPath}${safeFile}`
            }

            return ''
          })
        } else {
          const sent = await this.gfOpenWindow(async () => {
            const found = this.tableData.find(el => el.order_id === orderId)
            const wtsMessage = await this._getWtsMessage()
            const url = await this._getPaymentLink(found.school_id, orderId)
            if (url) {
              this.$common.log('url >>> '+url);
              const safeUrl = encodeURI(url);
              this.$common.log('safeUrl >>> '+safeUrl);
              return `https://api.whatsapp.com/send?phone=852${foundPhone.data}&text=${wtsMessage.replace(
                /(?:\r\n|\r|\n)/g,
                '%0A',
              )}%0A${safeUrl}`
            }

            return ''
          })
          // if (sent) {
          // this.updateInvoiceSent()
          // }
        }

        this.$refs.selectWtsDialog.hide()
      }
    },
    _getWtsMessage() {
      return new Promise(async (resolve, reject) => {
        // get center message
        try {
          if (!this.gDisableSettingByCenter) {
            const selectedSchool = this.gfGetUserSelectedSchool()
            if (selectedSchool > -1) {
              const data = await this.$Fetcher.GetSchoolById(selectedSchool)
              if (!data.basic_use_share) {
                resolve(data.whatsapp_message || '')
                return
              }
            }
          }
        } catch (err) {
          this.$common.error(err)
        }

        // else, get setting message
        try {
          const sData = await this.$Fetcher.GetSetting()
          resolve(sData.whatsapp_message || '')
        } catch (err) {
          this.$common.error(err)
          resolve('')
        }
      })
    },
    // async updateInvoiceSent(orderId) {
    //   try {
    //     await this.$Fetcher.UpdateOrder(orderId, {
    //       whatsapp_sent: true,
    //     })
    //   } catch (err) {
    //     this.$common.error(err)
    //   }
    // },

    // =============== 修改 ================
    async handleEditOrder(order, newOpen = true) {
      if (newOpen) {
        if (order.status === 'pending' && this.$validate.allowAction('PayTuitionPayment', this.userType)) {
          this.$router.push({ name: 'PayTuitionPayment', params: { id: order.student_id }, query: { order: order.id } })
          return
        } else {
          this.editOrderData.is_redeem = order.is_redeem
          this.editOrderData.payment_method = order.payment_method
          this.editOrderData.paymentImages = []
          if (order.payment_image_list.length > 0) {
            this.editOrderData.paymentImages = order.payment_image_list.map(file => {
              return { name: file, file: file }
            })
          }
          this.editOrderData.remark = order.remark || ''
          this.editOrderData.sign = order.sign || ''
          this.editOrderData.pdf_remark = order.pdf_remark || ''
          this.editOrderData.status = order.status
          this.editOrderData.order_create_date = order.order_date.substring(0, 10)
          this.editOrderData.order_create_time = order.order_date.substring(11, 16)
          this.editOrderData.pay_date = order.pay_date.substring(0, 10)
          this.editOrderData.pay_time = order.pay_date.substring(11, 16)

          this.editOrderData.order_code = order.order_code
          this.editOrderData.custom_invoice_number = order.custom_invoice_number
        }
      } else {
        this.$refs.editOrderDialog.setLoading(false)
      }

      const confirm = await this.$refs.editOrderDialog.show()
      if (confirm) {
        // 如果payment method係cash又未簽名，reject
        if (this.isAppMode(['T21'])) {
          if (
            !this.editOrderData.sign &&
            !this.editOrderData.is_redeem &&
            this.editOrderData.payment_method === 'cash'
          ) {
            this.$store.dispatch('toggleSnack', { message: 'message.signRequired', type: 'error' })
            this.handleEditOrder(order, false)
            return
          }
        }

        try {
          // ----------- payload ------------
          const getUser = this.gfGetCurrentUserData()

          let payload = {
            remark: this.editOrderData.remark,
            pdf_remark: this.editOrderData.pdf_remark,
            payment_method: this.editOrderData.payment_method,
            payment_image: '',
            staff_id: getUser.id,
          }

          // -- 付款記錄Image
          if (this.editOrderData.paymentImages.length) {
            if (!this.gDisableMultiplePaymentImg) {
              payload['payment_image_list'] = this.editOrderData.paymentImages.map(el => el.file)
            } else {
              payload['payment_image'] = this.editOrderData.paymentImages[0].file
            }
          } else if (!this.gDisableMultiplePaymentImg) {
            payload['payment_image_list'] = []
          }
          if (this.editOrderData.is_redeem) {
            delete payload['payment_method']
            delete payload['payment_image']
          }

          // -- 建立日期
          const newOrderDate = `${this.editOrderData.order_create_date}T${this.editOrderData.order_create_time}:00Z`
          if (newOrderDate.substring(0, 16) !== order.order_date.substring(0, 16)) {
            payload['order_date'] = newOrderDate
          }
          // -- 付款日期
          if (order.status === 'paid' && this.editOrderData.pay_date && this.editOrderData.pay_time) {
            const newPayDate = `${this.editOrderData.pay_date}T${this.editOrderData.pay_time}:00Z`
            if (newPayDate.substring(0, 16) !== order.pay_date.substring(0, 16)) {
              payload['pay_date'] = newPayDate
            }
          }

          // -- 電子簽名
          let uploadedSign = ''
          if (this.isAppMode(['T21'])) {
            if (!this.editOrderData.is_redeem && payload['payment_method'] === 'cash') {
              uploadedSign = await this._uploadSign(this.editOrderData.sign)
              if (uploadedSign !== false) {
                this.editOrderData.sign = uploadedSign
              }
            }

            payload['sign'] = ''
            if (uploadedSign !== false) {
              payload['sign'] = uploadedSign
            }
          }

          // -- 自訂訂單編號
          if (this.isAppMode(['DEV', 'T21'])) {
            payload['custom_invoice_number'] = this.editOrderData.custom_invoice_number
          }
          // ---------- End of payload ----------

          await this.$Fetcher.UpdateOrder(order.id, payload)
          if (!this.isAppMode(['T01'])) {
            if ((order.status === 'paid' || order.status === 'debit') && order.receipt_pdf) {
              const confirmRegen = await this.confirmRef.show({
                message: 'message.regenReceiptAfterEdit',
                confirmBtnText: 'need',
                cancelBtnText: 'noNeed',
              })
              if (confirmRegen) {
                await this.exportReceipt(order.id, true)
              }
            } else if ((order.status === 'pending' || order.status === 'processing') && order.invoice_pdf) {
              const confirmRegen = await this.confirmRef.show({
                message: 'message.regenInvoiceAfterEdit',
                confirmBtnText: 'need',
                cancelBtnText: 'noNeed',
              })
              if (confirmRegen) {
                await this.exportInvoice(order.id, true)
              }
            }
          }
          this.$refs.editOrderDialog.hide()
          this.$store.dispatch('toggleSnack', {
            message: 'message.saveSuccess',
            type: 'success',
          })
          this.getOrderData(false)
        } catch (err) {
          this.showAlert({
            title: 'message.saveFail',
            message: err,
            isError: true,
          })
          this.handleEditOrder(order, false)
        }
      }
    },

    // --(簽署)
    openSignPad() {
      if (this.$store.getters.isLoading) {
        this.$store.dispatch('toggleSnack', { message: 'processing' })
        return
      }
      this.$refs.signaturePadDialog.show()
    },
    _uploadSign(sign) {
      return new Promise(async (resolve, reject) => {
        if (sign) {
          if (sign.indexOf('data:image') > -1) {
            const payload = {
              upload_data: sign,
              upload_file_type: 'png',
            }
            try {
              const data = await this.$Fetcher.UploadFile(payload)
              resolve(data)
            } catch (err) {
              this.$common.error(err)
              resolve(false)
            }
          } else {
            resolve(sign)
          }
        } else {
          resolve('')
        }
      })
    },

    // ============== Log Record =============
    openLogRecord(order_id) {
      this.logOrderId = order_id
      this.$refs.logDialog.show()
      this.getLogData()
    },
    async getLogData() {
      if (this.canViewLog && this.$refs.logTableRef) {
        this.logLoading = true
        const filter = this.$refs.logTableRef.getFilter()
        try {
          const payload = {
            page: filter.page - 1,
            limit: filter.limit,
          }
          const { data, total } = await this.$Fetcher.GetOrderLogs(this.logOrderId, payload)
          this.logTableData = data
          this.logTableTotal = total
        } catch (err) {
          this.$common.error(err)
          this.logTableData = []
          if (filter.page === 1) {
            this.logTableTotal = 0
          }
        } finally {
          this.logLoading = false
        }
      }
    },

    async handleSiteLoaded() {
      this.$common.log('>>>>>>>>>>>>>>>>>>>>>>>>>>>> handleSiteLoaded: OrderList')
      this.userType = this.gfGetUserType()
      if (this.disabledMultiTypeSearch) {
        this.filter.searchType = 'order_id'
      }
      this._getQuery()
      this.$store.dispatch('toggleLoadingPage', false)
      this.getOrderData(false)
    },
  },
  destroyed() {
    window.removeEventListener('onSiteLoaded', this.handleSiteLoaded)
  },
  mounted() {
    this.tableLoading = true
    this.$store.dispatch('toggleLoadingPage', true)
    window.addEventListener('onSiteLoaded', this.handleSiteLoaded)
  },
  created() {
    this.createTimeOptions = []
    for (let i = 0; i < 24; i++) {
      for (let j = 0; j < 60; j++) {
        this.createTimeOptions.push(`${this.$formatter.pad(i)}:${this.$formatter.pad(j)}`)
      }
    }
  },

  // ------ navigation guard ------
  beforeRouteLeave(to, from, next) {
    this.$XHR.abort()
    next()
  },
}
</script>
